import React from 'react'
import { Box } from '@mui/material'
import { GDriveLogin } from '../tree/googleApis/GDriveLogin'
import { useCreatePresentationJob, useDeletePresentationJob } from './hooks'
import { OutlinedButton } from 'shared/ui'
import { CurrentFolder } from './CurrentFolder'
import { CurrentJobData } from './CurrentJobData'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { doesCurrentStatusExistAtom } from './atoms'
import { BorderedContainer } from '../utility/Containers'

export function PresentationFilesIndex() {
  return (
    <Box>
      <Box>Presentation Files Maintenance</Box>
      <JobIndex />
    </Box>
  )
}

function JobIndex() {
  return (
    <Box padding="10px">
      <CurrentFolder />
      <JobControls />
      <CurrentJobData />
    </Box>
  )
}

function JobControls() {
  return (
    <BorderedContainer>
      <DeleteJobButton />
      <StartJob />
    </BorderedContainer>
  )
}

function StartJob() {
  const currentStatusExist = useAtomValue(doesCurrentStatusExistAtom)
  const doCreator = useCreatePresentationJob()
  const TheButton = () => {
    return (
      <Box>
        <OutlinedButton onClick={doCreator}>Create Job</OutlinedButton>
      </Box>
    )
  }
  if (currentStatusExist) return null
  return <GDriveLogin LoggedInComponent={TheButton} />
}

function DeleteJobButton() {
  const currentStatusExist = useAtomValue(doesCurrentStatusExistAtom)
  const doDelete = useDeletePresentationJob()
  if (!currentStatusExist) return null
  return <OutlinedButton onClick={doDelete}>Delete Job</OutlinedButton>
}
